(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4501],{

/***/ 62184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DropdownList_DropdownList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(96394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 6 modules
var Select = __webpack_require__(66851);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./components/DropdownList/DropdownList.module.scss
var DropdownList_module = __webpack_require__(90402);
var DropdownList_module_default = /*#__PURE__*/__webpack_require__.n(DropdownList_module);
;// CONCATENATED MODULE: ./components/DropdownList/DropdownList.tsx





var DropdownList = function(param) {
    var id = param.id, label = param.label, value = param.value, testId = param.testId, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _tooltipMessage = param.tooltipMessage, tooltipMessage = _tooltipMessage === void 0 ? "" : _tooltipMessage, onChange = param.onChange, renderOptions = param.renderOptions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
        className: (DropdownList_module_default()).container,
        fullWidth: true,
        "data-testid": "select-container-".concat(id),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                id: "label-".concat(id),
                shrink: value !== undefined,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: tooltipMessage,
                interactive: !tooltipMessage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                    id: id,
                    labelId: "label-".concat(id),
                    value: value || "",
                    IconComponent: ExpandMore/* default */.Z,
                    onChange: onChange,
                    inputProps: {
                        "data-testid": testId
                    },
                    disabled: disabled,
                    children: renderOptions()
                })
            })
        ]
    });
};
/* harmony default export */ var DropdownList_DropdownList = (DropdownList);

;// CONCATENATED MODULE: ./components/DropdownList/index.tsx



/***/ }),

/***/ 70884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LocationSearchAutocomplete_LocationSearchAutocomplete; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/locationService.ts
var locationService = __webpack_require__(2589);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 3 modules
var Autocomplete = __webpack_require__(53437);
// EXTERNAL MODULE: ./components/LocationSearchAutocomplete/LocationSearchAutocomplete.module.scss
var LocationSearchAutocomplete_module = __webpack_require__(43188);
var LocationSearchAutocomplete_module_default = /*#__PURE__*/__webpack_require__.n(LocationSearchAutocomplete_module);
;// CONCATENATED MODULE: ./components/LocationSearchAutocomplete/LocationSearchAutocomplete.tsx













var LocationSearchAutocomplete = function(param) {
    var _selectedLocation = param.selectedLocation, selectedLocation = _selectedLocation === void 0 ? {
        name: ""
    } : _selectedLocation, onSelectedLocationChange = param.onSelectedLocationChange, _label = param.label, label = _label === void 0 ? "Country, State, or City" : _label, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Country, State, or City" : _placeholder;
    var ref = (0,react.useState)([]), locations = ref[0], setLocations = ref[1];
    var ref1 = (0,react.useState)(""), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,react.useState)(false), openOptions = ref2[0], setOpenOptions = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var onSearchTermChange = lodash_debounce_default()(function(term) {
        return setSearchTerm(term);
    }, 500);
    (0,react.useEffect)(function() {
        if (searchTerm.length >= 2) {
            setLocations([]);
            setLoading(true);
            setOpenOptions(true);
            var fetchLocations = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var data, mappedLocations;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0,locationService/* searchLocation */.h)(searchTerm)
                                ];
                            case 1:
                                data = _state.sent();
                                mappedLocations = data.locations.map(function(loc, idx) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loc), {
                                        divider: idx === data.locations.length - 1
                                    });
                                }).concat(data.results);
                                setLocations(mappedLocations);
                                setLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchLocations() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchLocations().catch(function() {
                return setOpenOptions(false);
            });
        } else {
            setOpenOptions(false);
        }
    }, [
        searchTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
        value: selectedLocation,
        onChange: function(_event, value) {
            onSelectedLocationChange(value);
            setOpenOptions(false);
        },
        ListboxProps: {
            style: {
                maxHeight: 250,
                overflow: "auto"
            }
        },
        "data-testid": "location-search-autocomplete",
        options: locations,
        autoHighlight: true,
        filterOptions: function(options) {
            return options;
        },
        popupIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
        clearOnBlur: true,
        open: openOptions,
        loading: !locations.length && loading,
        loadingText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            display: "flex",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                m: "auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
            })
        }),
        noOptionsText: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-testid": "job-search-no-options",
            children: [
                "The location ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: searchTerm
                }),
                " cannot be found."
            ]
        }),
        getOptionLabel: function(option) {
            return option.name;
        },
        getOptionSelected: function(option, value) {
            return option.name === value.name;
        },
        renderOption: function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: option.divider ? (LocationSearchAutocomplete_module_default()).divider : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-testid": "".concat(option.name).concat(option.city ? option.city : ""),
                            children: option.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (LocationSearchAutocomplete_module_default()).locationSubTitle,
                            children: [
                                option.city,
                                option.state,
                                option.country
                            ].filter(function(val) {
                                return !!val;
                            }).join(", ")
                        })
                    ]
                })
            });
        },
        renderInput: function(params) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                placeholder: placeholder,
                label: label,
                inputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.inputProps), {
                    maxLength: 200,
                    "data-testid": "job-search-location-autocomplete-input"
                }),
                onFocus: function() {
                    setOpenOptions(false);
                    setSearchTerm("");
                },
                onChange: function(e) {
                    return onSearchTermChange(e.target.value);
                },
                onBlur: function() {
                    return setOpenOptions(false);
                }
            }));
        }
    });
};
/* harmony default export */ var LocationSearchAutocomplete_LocationSearchAutocomplete = (LocationSearchAutocomplete);

;// CONCATENATED MODULE: ./components/LocationSearchAutocomplete/index.tsx



/***/ }),

/***/ 2589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ searchLocation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17673);




var api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    paramsSerializer: function(params) {
        return querystring__WEBPACK_IMPORTED_MODULE_1__.stringify(params);
    }
});
var searchLocation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(term) {
        var response, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        api.get("/api/locations", {
                            params: {
                                q: term
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 2:
                    error = _state.sent();
                    throw new Error("Failed to load locations", {
                        cause: error
                    });
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function searchLocation(term) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 73208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B5": function() { return /* binding */ getRadiusOptions; },
/* harmony export */   "HN": function() { return /* binding */ getSubSpecialityOptions; },
/* harmony export */   "J_": function() { return /* binding */ DEFAULT_RADIUS; },
/* harmony export */   "Lc": function() { return /* binding */ getSpecialityOptions; },
/* harmony export */   "Tu": function() { return /* binding */ getRootSpecialityOptions; },
/* harmony export */   "XG": function() { return /* binding */ MIN_PAY_RATES; },
/* harmony export */   "i$": function() { return /* binding */ DEFAULT_MIN_PAY_RATE_UNIT; },
/* harmony export */   "mG": function() { return /* binding */ getGradeOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85639);


var DEFAULT_RADIUS = "50";
var DISTANCES = [
    "25",
    "50",
    "75",
    "100",
    "150"
];
var radiusOptions = DISTANCES.map(function(radius) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        value: radius,
        children: [
            radius,
            " km"
        ]
    }, radius);
});
var getRadiusOptions = function() {
    return radiusOptions;
};
var getGradeOptions = function(grades) {
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: "None"
            })
        }, "none"), 
    ];
    if (grades) {
        grades.forEach(function(grade) {
            return grade && options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                value: grade.value,
                "data-testid": grade.key,
                children: grade.value
            }, grade.key));
        });
    }
    return options;
};
var getSpecialityOptions = function(selectedGrade, specialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: selectedGrade ? "None" : "Please select a grade"
            })
        }, "none"), 
    ];
    selectedGrade && specialities[selectedGrade] && ((ref = specialities[selectedGrade]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var getRootSpecialityOptions = function(selectedGrade, specialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: selectedGrade ? "None" : "Please select a grade"
            })
        }, "none"), 
    ];
    selectedGrade && specialities[selectedGrade] && ((ref = specialities[selectedGrade]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var getSubSpecialityOptions = function(speciality, subSpecialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: speciality ? "None" : "Please select a speciality"
            })
        }, "none"), 
    ];
    speciality && subSpecialities[speciality] && ((ref = subSpecialities[speciality]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var DEFAULT_MIN_PAY_RATE_UNIT = "Hourly";
var MIN_PAY_RATES = {
    Hourly: [
        "75",
        "100",
        "125",
        "200",
        "250",
        "300"
    ],
    Daily: [
        "500",
        "600",
        "700",
        "800",
        "900",
        "1000",
        "1250",
        "1500",
        "1750",
        "2000",
        "2500",
        "3000", 
    ]
};


/***/ }),

/***/ 80059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dy": function() { return /* binding */ getGradeCookie; },
/* harmony export */   "Hl": function() { return /* binding */ setLocationCookie; },
/* harmony export */   "Jz": function() { return /* binding */ getLocationCookie; },
/* harmony export */   "Me": function() { return /* binding */ setSpecialityCookie; },
/* harmony export */   "nj": function() { return /* binding */ getSpecialityCookie; },
/* harmony export */   "r8": function() { return /* binding */ setGradeCookie; },
/* harmony export */   "yD": function() { return /* binding */ mapJobSearchLocationCookieToPreferredWorkLocation; }
/* harmony export */ });
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);

var JOB_SEARCH_GRADE_COOKIE = "mr-job-search-grade";
var JOB_SEARCH_SPECIALITY_COOKIE = "mr-job-search-speciality";
var JOB_SEARCH_LOCATION_COOKIE = "mr-job-search-location";
var JOB_SEARCH_COOKIE_LIFE_IN_MS = 24 * 60 * 60 * 1000; // 24 hours
var getGradeCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_GRADE_COOKIE);
    if (value && typeof value === "string") {
        return value;
    }
    return null;
};
var setGradeCookie = function(grade) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_GRADE_COOKIE, grade, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var getSpecialityCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_SPECIALITY_COOKIE);
    if (value && typeof value === "string") {
        return value;
    }
    return null;
};
var setSpecialityCookie = function(speciality) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_SPECIALITY_COOKIE, speciality, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var getLocationCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_LOCATION_COOKIE);
    if (value && typeof value === "string") {
        var parsedValue;
        try {
            parsedValue = JSON.parse(value);
        } catch (_e) {
            return null;
        }
        if ((parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.name) && (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.country)) {
            return {
                name: parsedValue.name,
                state: parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.state,
                country: parsedValue.country
            };
        }
    }
    return null;
};
var setLocationCookie = function(locationCoordinate) {
    var value = JSON.stringify({
        name: locationCoordinate.name,
        state: locationCoordinate === null || locationCoordinate === void 0 ? void 0 : locationCoordinate.state,
        country: locationCoordinate.country
    });
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_LOCATION_COOKIE, value, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var mapJobSearchLocationCookieToPreferredWorkLocation = function(locationCookie) {
    if (!locationCookie) {
        return null;
    }
    // country level
    if (locationCookie.name === "New Zealand") {
        return {
            key: "New Zealand",
            value: "Anywhere in New Zealand"
        };
    }
    if (locationCookie.name === "Australia") {
        return {
            key: "Australia",
            value: "Anywhere in Australia"
        };
    }
    // NZ locations
    if (locationCookie.country === "New Zealand") {
        if (locationCookie.name === "South Island") {
            return {
                key: "South Island of New Zealand",
                value: "South Island of New Zealand"
            };
        }
        if (locationCookie.name === "North Island") {
            return {
                key: "North Island of New Zealand",
                value: "North Island of New Zealand"
            };
        }
        return {
            key: "New Zealand",
            value: "Anywhere in New Zealand"
        };
    }
    // AU locations
    if (locationCookie.country === "Australia") {
        if (locationCookie.name === "Victoria" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Victoria") {
            return {
                key: "Victoria Australia",
                value: "Victoria Australia"
            };
        }
        if (locationCookie.name === "New South Wales" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "New South Wales") {
            return {
                key: "New South Wales Australia",
                value: "New South Wales Australia"
            };
        }
        if (locationCookie.name === "Queensland" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Queensland") {
            return {
                key: "Queensland Australia",
                value: "Queensland Australia"
            };
        }
        if (locationCookie.name === "South Australia" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "South Australia") {
            return {
                key: "South Australia",
                value: "South Australia"
            };
        }
        if (locationCookie.name === "Australian Capital Territory" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Australian Capital Territory") {
            return {
                key: "Australian Capital Territory",
                value: "Australian Capital Territory"
            };
        }
        if (locationCookie.name === "Tasmania" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Tasmania") {
            return {
                key: "Tasmania Australia",
                value: "Tasmania Australia"
            };
        }
        if (locationCookie.name === "Western Australia" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Western Australia") {
            return {
                key: "Western Australia",
                value: "Western Australia"
            };
        }
        if (locationCookie.name === "Northern Territory" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Northern Territory") {
            return {
                key: "Northern Territory Australia",
                value: "Northern Territory Australia"
            };
        }
    }
    return null;
};


/***/ }),

/***/ 90402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownList_container__qnIXv"};

/***/ }),

/***/ 43188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"locationSubTitle":"LocationSearchAutocomplete_locationSubTitle__IKyaf","divider":"LocationSearchAutocomplete_divider__d4la1"};

/***/ }),

/***/ 84306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageHeadingCentered":"style_pageHeadingCentered__JWTNl","paddingBox":"style_paddingBox__VPFwP","pill":"style_pill___IWa_","detailTitle":"style_detailTitle__VO4bV","locationAndClient":"style_locationAndClient__grmXs","content":"style_content__YcKSS","noLoingNotice":"style_noLoingNotice__SfNCj","informationBox":"style_informationBox__tGsFl","hr":"style_hr__qLQSm","actions":"style_actions__UPrtJ","detailSubTitle":"style_detailSubTitle__HKqRv","detailContentApply":"style_detailContentApply__Mkju4","reference":"style_reference__S43WL","article":"style_article__4v2W1","landingContainer":"style_landingContainer__lg_xE","title":"style_title___Ri5x","more":"style_more__RW_RU","emptyJob":"style_emptyJob__zOwAM","link":"style_link__XPI_n","unavailableHeader":"style_unavailableHeader__0iKXc","searchBtn":"style_searchBtn___YQef","similarJobTitle":"style_similarJobTitle__zBdr_","shareBox":"style_shareBox__IaYkO","status":"style_status___9y_n","posRel":"style_posRel__BLElf","jobListContainer":"style_jobListContainer__E01Bx","similarJobs":"style_similarJobs__D_D6R","jobDetailsContainer":"style_jobDetailsContainer__EXizB","enquireButton":"style_enquireButton__BAqF2","bannerButton":"style_bannerButton__bdmTq","iconButton":"style_iconButton__qvS4b"};

/***/ })

}]);